
import { Formik } from "formik";
import React, { FormEvent, useEffect, useState } from "react";
import * as Yup from 'yup'
import NotificationView from "../../components/notification_view";
import Sidebar from "../../components/sidebar";
import { getQueryString, getStoredUserData, getUserSession } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { ApiClient } from "../../utils/apiclient";
import { ISelectOption, IUser, IUserDepartment, IUserPosition } from "../../utils/types";
import { ToastContainer, toast } from 'react-toastify';
import Spinner from "../../components/spinner";
import TopStrip from "../../components/top_strip";
import Select from 'react-select'

const CreateUserForm = (props: any) => {
    const userData = getStoredUserData();
    const userSession = getUserSession();
    const client = new ApiClient(userSession?.accessToken);
    const navigate = useNavigate()
    const [departments, setDepartments] = useState<IUserDepartment[]>([])
    const [positions, setPositions] = useState<IUserPosition[]>([])
    const [selectedDepartment, setSelectedDepartment] = useState<ISelectOption | null>(null)
    const [selectedPosition, setSelectedPosition] = useState<ISelectOption | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const handleCancel = () => {
        navigate(-1)
    }
    useEffect(() => {
        if (!getUserSession()) {
            const target = `${window.location.pathname}${getQueryString(window.location.href)}`
            console.log("🚀 ~ CreateUserForm ~ target:", target)
            navigate('/login',{state: {targetPath: target}})
        }
        else loadData()
    }, [])

    const sendUserForm = async (user: IUser) => {
        setLoading(true)
        const request = await client.addUser(user);
        setLoading(false)
        if (request.status == 201) {
            toast.success(request.data.result.msg, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
            setTimeout(() => {
                navigate(-1)
            }, 5000)
        }
        else alert(request.data)
    }

    const formHandler = (values: any) => {
        const department: IUserDepartment | undefined = departments.find((d: IUserDepartment) => d.id == selectedDepartment?.value)
        const location = department ? department.region : 'Dar es salaam';
        const user: IUser = {
            email: values.email,
            phone: values.phone,
            emp_id: values.employee_id,
            username: values.email,
            fname: values.fname,
            lname: values.lname,
            location: location,
            department: Number(selectedDepartment?.value),
            position: Number(selectedPosition?.value),
            password: values.password,
            busy: 0
        }
        console.log("🚀 ~ formHandler ~ user:", user)
        sendUserForm(user)
    }
    const formValidationSchema = Yup.object({
        email: Yup.string().required('Email address required').email('Please enter a valid email address'),
        fname: Yup.string().required('First name is required').min(2, "Name too short"),
        lname: Yup.string().required('Last name is required').min(2, 'Name too short'),
        department: Yup.number().required('Please select department'),
        position: Yup.number().required('Please select position'),
        password: Yup.string().required('Please provide a password').min(8, 'Password is too short'),
        phone: Yup.string().required("Please enter a phone number")
    })

    const loadData = async () => {
        const [positions, departments] = await Promise.all([client.getPositions(), client.getDepartments()]);
        setDepartments(departments)
        setPositions(positions)
    }
    const showNotifications = () => {
        navigate(`/notifications/${userData?.id}`)
    }
    const handleDepartmentChange = (selectedOption: ISelectOption | null) => {
        setSelectedDepartment(selectedOption);
    };
    const handlePositionChange = (selectedOption: ISelectOption | null) => {
        setSelectedPosition(selectedOption);
    };
    
    return (<>
        <div className="w-full flex justify-end items-center bg-gray-100 pe-4">
            <TopStrip user={userData} />
        </div>
        <ToastContainer />
        <main className="w-full flex bg-white min-h-full">

            <div className="md:w-2/12 flex flex-col items-start text-center justify-center">
                <Sidebar notificationCount={[].length} user={userData} active={2} />                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 f
            </div>

            <div className="md:w-9/12 mx-auto space-y-4 mt-2">

                <div className="w-full">
                    <div className="w-full flex items-center justify-between p2-4">
                        <p className="text-2xl font-bold">Create User</p>
                    </div>
                    <div className="w-full md:w-8/12 flex justify-center py-4 mx-auto">
                        <Formik validationSchema={formValidationSchema} initialValues={{ phone: "", email: "", password: "", lname: "", fname: "", position: 0, department: 0 }} onSubmit={formHandler}>
                            {({ handleSubmit, handleChange, values, errors, touched }) => (
                                <form
                                    name="new-user-form"
                                    id="new-user-form" className="w-full mt-4 border py-8"
                                    onSubmit={handleSubmit}
                                >

                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label className="text-gray-600" htmlFor="employee_id">
                                                Employee ID
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control"
                                                type="text"
                                                name="employee_id"
                                                id="employee_id"
                                                placeholder="Enter employee Id"
                                            />
                                        </div>
                                        <div className="w-full text-start">
                                            <label className="text-gray-600">
                                                Position
                                            </label>
                                            <Select
                                                onChange={setSelectedPosition}
                                                className=""
                                                name="position"
                                                id="position"
                                                options={positions.map((p: IUserPosition) => {
                                                    return {
                                                        value: p.id,
                                                        label: p.value
                                                    };
                                                })}
                                            />
                                               
                                            {!selectedPosition && <span className="text-red-400">{errors.position}</span>}
                                        </div>
                                    </div>

                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label
                                                htmlFor="fname" className="text-gray-600">
                                                First Name
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control "
                                                type="text"
                                                name="fname"
                                                id="fname"
                                                placeholder="First Name"
                                            />
                                            {touched && errors.fname && <span className="text-red-400">{errors.fname}</span>}
                                        </div>
                                    </div>
                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label
                                                htmlFor="lname"
                                                className="text-gray-600"
                                            >
                                                Last Name
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control"
                                                type="text"
                                                name="lname"
                                                id="lname"
                                                placeholder="Last Name"
                                            />
                                            {touched && errors.lname && <span className="text-red-400">{errors.lname}</span>}
                                        </div>
                                    </div>
                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label className="text-gray-600" htmlFor="email">
                                                E-mail
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control "
                                                type="text"
                                                name="email"
                                                id="email"
                                                placeholder="Enter email address"
                                            />
                                            {errors.position && <span className="text-red-400">{errors.position}</span>}

                                        </div></div>
                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label
                                                htmlFor="department"
                                                className="text-gray-600"
                                            >
                                                Department
                                            </label>
                                            <Select
                                                onChange={(e:any) => handleDepartmentChange(e)}
                                                className=""
                                                name="department"
                                                id="department"
                                                options={departments.map((d: any) => {
                                                    return {
                                                        value: d.id,
                                                        label: d.description + " (" + d.code + ")"
                                                    };
                                                })}
                                            />{!selectedDepartment && <span className="text-red-400">{errors.department}</span>}

                                        </div>
                                    </div>

                                    <div className="w-full md:w-9/12 mx-auto">
                                        <div className="w-full text-start">
                                            <label
                                                htmlFor="phone"
                                                className="text-gray-600"
                                            >
                                                Phone
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control "
                                                type="text"
                                                name="phone"
                                                id="phone"
                                                placeholder="Enter a phone number"
                                            />
                                            {errors.phone && <span className="text-red-400">{errors.phone}</span>}

                                        </div>

                                        <div className="w-full text-start">
                                            <label
                                                htmlFor="password"
                                                className="text-gray-600"
                                            >
                                                Password
                                            </label>
                                            <input onChange={handleChange}
                                                className="form-control "
                                                type="password"
                                                name="password"
                                                id="password"
                                                placeholder="Enter a password"
                                            />
                                            {errors.password && <span className="text-red-400">{errors.password}</span>}
                                        </div>
                                    </div>


                                    <div className="w-full md:w-9/12 mx-auto">
                                        <span className="flex items-center justify-between">
                                            <button
                                                className={`py-1 px-2 text-white w-full md:w-3/12 ${Object.values(errors).length > 0 ? 'disabled bg-gray-500' : 'bg-accent'} `}
                                                type="submit"
                                                id="submitUser"
                                            >{loading ? <Spinner className="spinner-sm-white my-2" /> : 'Save'}</button>

                                            <button
                                                id="cancel-user"
                                                className="border border-accent w-3/12 text-accent"
                                                onClick={handleCancel}
                                            >
                                                CANCEL
                                            </button>
                                        </span>
                                    </div>
                                </form>
                            )
                            }
                        </Formik >

                    </div >
                </div>
            </div>
        </main>
    </>);

}
export default CreateUserForm;
